<template>
    <div class="body-feedback">
        <div class="index"
        :style="{
            background: colors.theme == 'dark' ? '#273a45' : '#fff'
        }">
            <span class="value" 
            :style="{
                color: colors.theme == 'dark' ? '#fff' : '#000',
                'text-shadow': colors.theme == 'dark' ? '3px 2px 0px #000' : '3px 2px 0px #c5cad3'     
            }">{{index}}</span>
        </div>
        <div class="title-feedback">
            <span class="title" :style="{ color: colors.theme == 'dark' ? '#fff' : '#000' }">
                {{beforeBold}} 
                    <span class="bold"> {{titleBold}} </span>  
                {{afterBold }}
            </span>
        </div>
        <div class="content-feedback">
            <slot></slot>
        </div>
        <div class="button-feedback">
            <button-feedback :actionName="actionName" :status="statusButton" textButton="próximo"></button-feedback>
            <!-- :style="{'background-color': colors.secondary, 'border-color': colors.theme == 'dark' ? '#00131f' : '#c7c7c7'}" -->
            <div class="arrow-right"></div>
        </div>
    </div>
</template>
<script>
import ButtonFeedback from '../Buttons/ButtonFeedback.vue'
import Bus from '../../main.js'
export default {
    data() {
        return{
            statusButton : 'disabled',
            colors: {}
        }
    },
    created(){
        Bus.$on('ableButton', this.ableButton)
        Bus.$on('disableButton', this.disableButton)
        this.colors = JSON.parse(localStorage.getItem("colors"));
    },
    methods: {
        ableButton(){
            this.statusButton = 'statusButton'
        },
        disableButton(){
            this.statusButton = 'disabled'
        }
    },
    components: {
        ButtonFeedback
    },
    props : {
        beforeBold : {
            type : String
        },
        afterBold : {
            type : String
        },
        title : {
            type : String
        },
        titleBold : {
            type : String
        },
        actionName : {
            type : String,
            required : true
        },
        index:{
            type: Number
        }
    }
}
</script>
<style lang="scss" scoped>

    .body-feedback{
        margin: 32px auto;
        display: flex;
        flex-direction: column;
        overflow-y: auto;

        .index{
            display: flex;
            justify-content: center;
            align-items: center;
            margin: 32px auto 0;
            padding: 5px 25px;
            background: #333;
            border-radius: 300px;   
            font-weight: 800;
            font-size: 70px; 
            flex-direction: column;               
            
            .value{
                position: relative;
                bottom: 5px;              
            }
                         
        }
        

        .title-feedback{

            margin : 35px auto;
            width: 80%;
            text-align: center;
            
            
            .title{ 

                font-size: 18px;
                line-height: 24px;
            }
        }
        .button-feedback {
            width: 80%;
            margin: 10px auto;
            display: flex;
            flex-direction: row;
            align-items: center;
            max-width: 300px;

            button{
                border-top: none !important;
                padding: 25px 0 !important;
                font-size: 15px;
                border-radius: 300px;
                color: #fff;
            }

            .arrow-right {
                height: 0;
                border-top: 6px solid transparent;
                border-bottom: 6px solid transparent;
                border-left: 6px solid #fff;
                width: 0;
                position: relative;
                right: 33px;
            }      
        }
    }
</style>
